module.exports = __webpack_public_path__ + "static/media/home-hebebuehne.8dbef700.jpeg";